import { createContext, useContext } from 'react'

/**
 * How a view registers the elements the cursor travels to.
 *
 * A context rather than a prop: the screens are separate components per
 * announcement, and threading a `registerTarget` callback through each of them
 * would put plumbing in every view for something only the stage cares about.
 */
export const TargetContext = createContext<(key: string) => (node: HTMLElement | null) => void>(() => () => {})

/** The screen currently on stage; `JourneyView` compares itself against it. */
export const ViewContext = createContext<string>('')

/** Ref callback that lets the cursor find this element by key. */
export const useTarget = (key: string) => useContext(TargetContext)(key)

/**
 * How a pan finds the element it scrolls to. Separate from `TargetContext`
 * because registering is what every view does, and looking up is what only a
 * scrolling screen needs.
 */
export const TargetLookupContext = createContext<(key: string) => HTMLElement | null>(() => null)
